import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

interface FieldProps {
  span?: number
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const Title = styled.h5`
  color: ${theme.colors.neutral.black};
  font-size: ${theme.typography.sizes['2md']};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.xl};

  margin: 0px;
  padding-left: 5px;
`

export const Form = styled.form`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: ${theme.spacing.md};
`

export const Field = styled.div<FieldProps>`
  display: flex;
  flex-direction: column;
  grid-column: span ${({ span }) => span || 2};
`

export const HozDivider = styled.div`
  grid-column: span 8;
  border-bottom: 1px solid ${theme.colors.neutral.clear};
`

export const SizeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const InsertionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  p {
    color: ${theme.colors.primary.main} !important;
  }
`

export const ErrorWrapper = styled(ColWrapper)`
  overflow: auto;
  gap: ${theme.spacing.md};
`

export const UploadedFileViewer = styled.div`
  display: flex;
  align-items: center;
  height: 62px;
  width: 100%;
  padding: 16px;
  gap: ${theme.spacing.xs};
  border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.mediumhover};
  border-radius: ${theme.shapes.borderRadius.sm};
  p {
    color: ${theme.colors.neutral.high} !important;
  }
`

export const ErrorOrderHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: ${theme.spacing.xs};
  align-items: center;
`

export const DeleteOrdersActions = styled.div`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.xs};
  justify-content: flex-end;
  padding-top: ${theme.spacing.md};
  margin-top: ${theme.spacing.md};
  border-top: solid 1px ${theme.colors.neutral.clear};
`

export const ErrorOrderActions = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
`
